export interface AuthenticationKeyboardOffsetOptions {
  isTablet: boolean;
  layoutHeight: number;
  viewportHeight: number;
  viewportOffsetTop?: number;
}

export const getAuthenticationKeyboardOffset = ({
  isTablet,
  layoutHeight,
  viewportHeight,
  viewportOffsetTop = 0,
}: AuthenticationKeyboardOffsetOptions): number => {
  if (!isTablet) {
    return 0;
  }

  return Math.max(0, layoutHeight - viewportHeight - viewportOffsetTop);
};
